export * from "./landing-page.component";
